import { Typography } from '@mui/material';
import React from 'react';

function AboutUser() {
  return <Typography variant="link">Tab About</Typography>;
}

export default AboutUser;
